module.exports = {
    status: 'initialize',
    jobs: null,
}